module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "tag-input"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'tag-input-field': true,
      'active': _vm.isOpen
    },
    on: {
      "click": _vm.openDrawer
    }
  }, _vm._l((_vm.selectedTags), function(tag) {
    return _c('div', {
      key: 'selectedTag_' + tag,
      staticClass: "tag"
    }, [_vm._v("\n        " + _vm._s(tag) + "\n        "), _c('span', {
      staticClass: "remove-tag",
      on: {
        "click": function($event) {
          _vm.removeTag(tag)
        }
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "version": "1.1",
        "width": "10",
        "height": "10",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M256.010 204.645l100.118-100.146 51.344 51.33-100.118 100.146-51.344-51.329z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M155.827 407.483l-51.344-51.358 100.161-100.132 51.344 51.358-100.161 100.132z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M407.498 356.112l-51.373 51.358-100.118-100.146 51.373-51.358 100.118 100.146z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M104.502 155.857l51.337-51.351 100.153 100.125-51.337 51.351-100.153-100.125z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M255.983 307.36l-51.351-51.365 51.365-51.351 51.351 51.365-51.365 51.351z"
      }
    })])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "tag-selection-box"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: 'option_' + option,
      class: {
        'tag': true,
        'tag--selected': _vm.tagIsAdded(option)
      },
      on: {
        "click": function($event) {
          _vm.addTag(option)
        }
      }
    }, [_vm._v("\n        " + _vm._s(option) + "\n        "), _c('div', {
      staticClass: "tag-status"
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-852f8796","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tagInput.vue
// module id = 609
// module chunks = 0